import { LinkBox, LinkOverlay, VStack } from '@chakra-ui/react'
import { CoverImage } from '@!/Store/Common/components/CoverImage'

export const Content = ({ contentId, contentName, imageUrl, sectionTitle }) => {
  return (
    <LinkBox w="100px">
      <VStack>
        <CoverImage src={imageUrl} alt={contentName} objectFit="contain" width="100px" />
        <LinkOverlay href={`/store/books/${contentId}`} {...(sectionTitle && { 'data-gtm-click': sectionTitle })} noOfLines={1} fontSize="sm" fontWeight="bold">
          {contentName}
        </LinkOverlay>
      </VStack>
    </LinkBox>
  )
}
